import Vue from 'vue';
import store from '@/store';
import Router from 'vue-router';
import Login from './views/Login.vue';
import users from '@/store/modules/users';
import { Helpers } from './tools/helpers';

Vue.use(Router);

const userLoadStatus = async () => {
  return store.getters.checkUserLoadStatus();
};
// https://dev.to/mygnu/vue-spa-router-guard-with-redirect-after-login-2anj
const guard = async (to: any, from: any, next: any) => {
  await userLoadStatus().then((result: any) => {
    if (store.getters.userLoggedIn) {
      router.app.$emit('routechanged', { to: to });
      users.refresh();

      if (store.getters.currentUser.user_type === 'user') {
        // allow to enter route
        if (to.matched.some((record: any) => record.meta.module)) {
          if (
            to.matched.some(
              (record: any) =>
                record.meta.module &&
                users.businessLicence.licence_definition.modules.some((m: any) => {
                  return m.name === record.meta.module;
                }),
            )
          ) {
            next();
          } else {
            next(`/needupgrade?name=${to.meta.nav_item}&child=${to.meta.child_nav_item}`);
          }
        } else {
          next();
        }
      } else {
        if (to.matched.some((record: any) => record.meta.user_type && record.meta.user_type === 'user')) {
          next(`/needbusinessaccount?name=${to.meta.nav_item}&child=${to.meta.child_nav_item}`);
        } else {
          next();
        }
      }
    } else {
      next('/'); // go to '/login';
    }
  });
};

const routechangedguard = async(to: any, from: any, next: any) => {
  await userLoadStatus().then((result: any) => {
    next();
  })
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Base',
      component: Login,
      meta: {
        public: true,
        general: true,
        header: 'none'
      },
    },
    {
      path: '/signup',
      name: 'Signup',
      component: () => import(/* webpackChunkName: "about" */ './views/Signup.vue'),
      meta: {
        public: true,
        general: true,
        header: 'none'
      },
    },
    {
      path: '/signup/invited/:organization_id/:code',
      name: 'SignupInvited',
      component: () => import(/* webpackChunkName: "about" */ './views/Signup.vue'),
      meta: {
        public: true,
        general: true,
        header: 'none'
      },
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import(/* webpackChunkName: "about" */ './views/Login.vue'),
      meta: {
        public: true,
        general: true,
        header: 'none'
      },
    },
    {
      path: '/resetpassword',
      name: 'ResetPassword',
      component: () => import(/* webpackChunkName: "about" */ './views/ForgotPassword.vue'),
      meta: {
        public: true,
        general: true,
      },
    },
    {
      path: '/verify/:code',
      name: 'VerifyUser',
      component: () => import(/* webpackChunkName: "about" */ './views/Login.vue'),
      meta: {
        public: true,
        general: true,
        header: 'none'
      },
    },
    {
      path: '/reverify/:code',
      name: 'ReverifyUser',
      component: () => import(/* webpackChunkName: "about" */ './views/Login.vue'),
      meta: {
        public: true,
        general: true,
        header: 'none'
      },
    },
    {
      path: '/reverify/invited/:organization_id/:code',
      name: 'ReverifyInvited',
      component: () => import(/* webpackChunkName: "about" */ './views/Login.vue'),
      meta: {
        public: true,
        general: true,
        header: 'none'
      },
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/Dashboard.vue'),
      meta: {
        on_project_change: 'reload',
        nav_item: 'Dashboard',
        header: 'loggedin'
      },
    },
    // {
    //   path: '/',
    //   name: 'Home',
    //   beforeEnter: guard,
    //   component: () => import(/* webpackChunkName: "about" */ './views/SearchMarketRequests.vue'),
    //   meta: {},
    // },
    {
      path: '/terms',
      name: 'Terms',
      component: () => import(/* webpackChunkName: "about" */ './views/TermsAndCondition.vue'),
    },
    {
      path: '/changepassword/:code?',
      name: 'ChangePassword',
      component: () => import(/* webpackChunkName: "about" */ './views/ChangePassword.vue'),
      meta: {
        public: true,
        general: true,
        header: 'none'
      },
    },
    {
      path: '/needupgrade',
      name: 'NeedUpgrade',
      beforeEnter: routechangedguard,
      component: () => import(/* webpackChunkName: "about" */ './views/NeedUpgrade.vue'),
      meta: {
        user_type: 'user',
        on_project_change: 'reload',
        header: 'loggedin'
      },
    },
    {
      path: '/needbusinessaccount',
      name: 'NeedBusinessAccount',
      component: () => import(/* webpackChunkName: "about" */ './views/NeedBusinessAccount.vue'),
      meta: {
        public: false,
        on_project_change: 'reload',
        header: 'loggedin'
      },
    },
    {
      path: '/suppliersearch',
      name: 'Search suppliers',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/Search.vue'),
      meta: {
        public: false,
        user_type: 'user',
        module: 'active_projects',
        breadcrumbs: [
          { text: 'Suppliers', navigateToPath: null, path: null, params: null },
          { text: 'Search suppliers', navigateToPath: null, path: null, params: null },
        ],
        on_project_change: 'reload',
        nav_item: 'Suppliers',
        child_nav_item: 'Search suppliers',
        header: 'loggedin'
      },
    },
    {
      path: '/supplierenquirysummary/:id/:mrid',
      name: 'SupplierEnquirySummaryParam',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/SupplierEnquirySummary.vue'),
      meta: {
        user_type: 'user',
        breadcrumbs: [
          { text: 'Work', navigateToPath: null, path: null, params: null },
          { text: 'Market Requests', navigateToPath: `/${Helpers.projectLabel.toLowerCase()}-market-requests`, path: `/${Helpers.projectLabel.toLowerCase()}-market-requests`, params: null },
          { text: null, navigateToPath: '/respondmarketrequest', path: '/respondmarketrequest', params: { id: null, mrid: null }, title: true, },
          { text: 'Message Board', navigateToPath: '/supplierenquirysummary', path: '/supplierenquirysummary', params: { id: null, mrid: null } },
        ],
        nav_item: 'Work',
        child_nav_item: 'Market Requests',
        header: 'loggedin'
      },
    },
    {
      path: '/respondmarketrequest/:id/:mrid',
      name: 'SubmitResponse',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/SubmitResponse.vue'),
      meta: {
        breadcrumbs: [
          { text: 'Work', path: null, params: null },
          { text: 'Market Requests', navigateToPath: `/${Helpers.projectLabel.toLowerCase()}-market-requests`, path: `/${Helpers.projectLabel.toLowerCase()}-market-requests`, params: null },
          { text: null, navigateToPath: '/respondmarketrequest', path: '/respondmarketrequest', params: { id: null, mrid: null }, title: true, },
        ],
        nav_item: 'Work',
        child_nav_item: 'Market Requests',
        header: 'loggedin'
      },
    },
    {
      path: '/buyermarketrequest/:id?',
      name: 'BuyerMarketRequest',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/NewMarketRequest.vue'),
      meta: {
        user_type: 'user',
        module: 'market_requests',
        breadcrumbs: [
          { text: `${Helpers.projectsLabel}`, navigateToPath: null, path: null, params: null },
          { text: 'Market Requests', navigateToPath: '/market-requests', path: '/market-requests', params: null },
          { text: 'Create New', navigateToPath: null, path: null, params: null, title: true, },
        ],
        on_project_change: 'MarketRequests',
        nav_item: `${Helpers.projectsLabel}`,
        child_nav_item: 'Market Requests',
        header: 'loggedin'
      },
    },
    {
      path: '/businessprofile/:bpid?',
      name: 'BusinessProfile',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/BusinessProfile.vue'),
      meta: {
        module: 'business_profile',
        nav_item: 'Business',
        header: 'loggedin'
      },
    },
    {
      path: '/your-networks',
      name: `My ${Helpers.projectsLabel}`,
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/MyProjects.vue'),
      meta: {
        user_type: 'user',
        module: 'active_projects',
        breadcrumbs: [
          { text: `${Helpers.projectsLabel}`, navigateToPath: null, path: null, params: null },
          { text: `Your ${Helpers.projectsLabel.toLowerCase()}`, navigateToPath: null, path: null, params: null },
        ],
        nav_item: `${Helpers.projectsLabel}`,
        child_nav_item: `Your ${Helpers.projectsLabel.toLowerCase()}`,
        header: 'loggedin'
      },
    },
    {
      path: '/users/:bpid?',
      name: 'UserManagement',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/RolesAndPermissions.vue'),
      meta: {
        user_type: 'user',
        module: 'business_profile',
        breadcrumbs: [{ text: 'Account', navigateToPath: null, path: null, params: null }, { text: 'User Management', navigateToPath: null, path: null, params: null }],
        nav_item: 'Account',
        child_nav_item: 'Users',
        header: 'loggedin'
      },
    },
    {
      path: `/${Helpers.projectNetworkLabel.replace(/\s+/g, '-').toLowerCase()}`,
      name: `${Helpers.projectLabel} Portal`,
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/ProjectPortal.vue'),
      meta: {
        breadcrumbs: [
          { text: 'Work', navigateToPath: null, path: null, params: null }, { text: `${Helpers.projectNetworkLabel}`, navigateToPath: null, path: null, params: null },
        ],
        nav_item: 'Work',
        child_nav_item: `${Helpers.projectNetworkLabel}`,
        header: 'loggedin'
      },
    },
    {
      path: `/${Helpers.projectNetworksLabel.replace(/\s+/g, '-').toLowerCase()}-list`,
      name: `${Helpers.projectNetworksLabel}List`,
      component: () => import(/* webpackChunkName: "about" */ './views/ProjectPortal.vue'),
      meta: {
        public: true,
        header: 'public'
      },
    },
    {
      path: `/${Helpers.projectLabel.toLowerCase()}-market-requests`,
      name: 'SearchMarketRequests',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/SearchMarketRequests.vue'),
      meta: {
        breadcrumbs: [
          { text: 'Work', navigateToPath: null, path: null, params: null }, { text: 'Market Requests', navigateToPath: null, path: null, params: null }
        ],
        nav_item: 'Work',
        child_nav_item: 'Market Requests',
        header: 'loggedin'
      },
    },
    {
      path: '/exchange',
      name: 'Exchange',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/Exchange.vue'),
      meta: {
        user_type: 'user',
        nav_item: 'Messages',
        child_nav_item: 'Messages',
        header: 'loggedin'
      },
    },
    {
      path: '/profile',
      name: 'profile',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/Profile.vue'),
      meta: {
        breadcrumbs: [
          { text: 'Account', navigateToPath: null, path: null, params: null },
          { text: 'Your Profile', navigateToPath: null, path: null, params: null },
        ],
        nav_item: 'Account',
        child_nav_item: 'Your Profile',
        header: 'loggedin'
      },
    },
    {
      path: `/${Helpers.projectLabel.toLowerCase()}/:id`,
      name: 'NetworkParam',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/Project.vue'),
      meta: {
        breadcrumbs: [
          { text: 'Work', navigateToPath: null, path: null, params: null },
          { text: `${Helpers.projectNetworkLabel}`, navigateToPath: `/${Helpers.projectNetworkLabel.replace(/\s+/g, '-').toLowerCase()}`, path: `/${Helpers.projectNetworkLabel.replace(/\s+/g, '-').toLowerCase()}`, params: null },
          { text: null, navigateToPath: null, path: null, params: { id: null }, title: true, }
        ],
        nav_item: 'Work',
        child_nav_item: `${Helpers.projectNetworkLabel}`,
        header: 'loggedin'
      },
    },
    {
      path: `/view/${Helpers.projectLabel.toLowerCase()}/:id/:name?`,
      name: 'NetworkView',
      component: () => import(/* webpackChunkName: "about" */ './views/Project.vue'),
      meta: {
        public: true,
        header: 'public'
      },
    },
    {
      path: '/registerinterest/:id',
      name: 'RegisterInterest',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/RegisterInterest.vue'),
      meta: {
        breadcrumbs: [
          { text: 'Work', navigateToPath: null, path: null, params: null },
          { text: `${Helpers.projectNetworkLabel}`, navigateToPath: `/${Helpers.projectNetworkLabel.replace(/\s+/g, '-').toLowerCase()}`, path: `/${Helpers.projectNetworkLabel.replace(/\s+/g, '-').toLowerCase()}`, params: null },
          { text: null, navigateToPath: `/${Helpers.projectLabel.toLowerCase()}`, path: `/${Helpers.projectLabel.toLowerCase()}`, params: { id: null }, title: true, }
        ],
        nav_item: 'Work',
        child_nav_item: `${Helpers.projectNetworkLabel}`,
        header: 'loggedin'
      },
    },
    {
      path: `/${Helpers.projectLabel.toLowerCase()}-dashboard`,
      name: `${Helpers.projectLabel} dashboard`,
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/BuyerProject.vue'),
      meta: {
        user_type: 'user',
        module: 'active_projects',
        breadcrumbs: [
          { text: `${Helpers.projectsLabel}`, navigateToPath: null, path: null, params: null },
          { text: `${Helpers.projectLabel} dashboard`, navigateToPath: null, path: null, params: null },
        ],
        on_project_change: 'reload',
        nav_item: `${Helpers.projectsLabel}`,
        child_nav_item: `${Helpers.projectLabel} dashboard`,
        header: 'loggedin'
      },
    },
    {
      path: '/newmarketrequest/:id',
      name: 'NewMarketRequestParam',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/NewMarketRequest.vue'),
      meta: {
        user_type: 'user',
        module: 'market_requests',
        on_project_change: 'reload',
        nav_item: `${Helpers.projectsLabel}`,
        child_nav_item: 'Market Requests',
        header: 'loggedin'
      },
    },
    {
      path: '/market-requests/:id?',
      name: 'MarketRequests',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/BuyerPackages.vue'),
      meta: {
        user_type: 'user',
        module: 'market_requests',
        breadcrumbs: [
          { text: `${Helpers.projectsLabel}`, navigateToPath: null, path: null, params: null },
          { text: 'Market Requests', navigateToPath: null, path: null, params: null },
        ],
        on_project_change: 'reload',
        nav_item: `${Helpers.projectsLabel}`,
        child_nav_item: 'Market Requests',
        header: 'loggedin'
      },
    },
    {
      path: '/buyermessageboard/:id/:mrid',
      name: 'BuyerMessageBoard',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/BuyerMessageBoard.vue'),
      meta: {
        user_type: 'user',
        module: 'market_requests',
        breadcrumbs: [
          { text: `${Helpers.projectsLabel}`, navigateToPath: null, path: null, params: null },
          { text: 'Market Requests', navigateToPath: '/market-requests', path: '/market-requests', params: null },
          { text: null, navigateToPath: '/viewmarketrequest', path: '/viewmarketrequest', params: { id: null, mrid: null }, title: true, },
          { text: 'Message Board', navigateToPath: '/buyermessageboard', path: '/buyermessageboard', params: { id: null, mrid: null } },
        ],
        on_project_change: 'MarketRequests',
        nav_item: `${Helpers.projectsLabel}`,
        child_nav_item: 'Market Requests',
        header: 'loggedin'
      },
    },
    {
      path: '/viewmarketrequest/:id/:mrid',
      name: 'ViewMarketRequest',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/ViewMarketRequest.vue'),
      meta: {
        user_type: 'user',
        module: 'market_requests',
        breadcrumbs: [
          { text: `${Helpers.projectsLabel}`, navigateToPath: null, path: null, params: null },
          { text: 'Market Requests', navigateToPath: '/market-requests', path: '/market-requests', params: null },
          { text: null, navigateToPath: '/viewmarketrequest', path: '/viewmarketrequest', params: { id: null, mrid: null }, title: true, },
        ],
        on_project_change: 'MarketRequests',
        nav_item: `${Helpers.projectsLabel}`,
        child_nav_item: 'Market Requests',
        header: 'loggedin'
      },
    },
    {
      path: '/viewResponses/:id/:mrid',
      name: 'ViewResponses',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/ResponseList.vue'),
      meta: {
        user_type: 'user',
        module: 'market_requests',
        breadcrumbs: [
          { text: `${Helpers.projectsLabel}`, navigateToPath: null, path: null, params: null },
          { text: 'Market Requests', navigateToPath: '/market-requests', path: '/market-requests', params: null },
          { text: null, navigateToPath: '/viewmarketrequest', path: '/viewmarketrequest', params: { id: null, mrid: null }, title: true, },
          { text: 'Responses', navigateToPath: '/viewResponses', path: '/viewResponses', params: { id: null, mrid: null } },
        ],
        on_project_change: 'MarketRequests',
        nav_item: `${Helpers.projectsLabel}`,
        child_nav_item: 'Market Requests',
        header: 'loggedin'
      },
    },
    {
      path: '/managesuppliers',
      name: 'Manage suppliers',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/SupplierManagement.vue'),
      meta: {
        user_type: 'user',
        module: 'active_projects',
        breadcrumbs: [
          { text: 'Suppliers', navigateToPath: null, path: null, params: null },
          { text: 'Manage suppliers', navigateToPath: null, path: null, params: null },
        ],
        on_project_change: 'reload',
        nav_item: 'Suppliers',
        child_nav_item: 'Manage suppliers',
        header: 'loggedin'
      },
    },
    {
      path: '/managecategories',
      name: 'Manage categories',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/CategoryManagement.vue'),
      meta: {
        user_type: 'user',
        module: 'active_projects',
        breadcrumbs: [
          { text: `${Helpers.projectsLabel}`, navigateToPath: null, path: null, params: null },
          { text: 'Manage categories', navigateToPath: null, path: null, params: null },
        ],
        on_project_change: 'reload',
        nav_item: `${Helpers.projectsLabel}`,
        child_nav_item: 'Manage categories',
        header: 'loggedin'
      },
    },
    {
      path: '/response/:id/:mrid/:resid',
      name: 'ViewResponse',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/SupplierResponse.vue'),
      meta: {
        user_type: 'user',
        module: 'market_requests',
        breadcrumbs: [
          { text: `${Helpers.projectsLabel}`, navigateToPath: null, path: null, params: null },
          { text: 'Market Requests', navigateToPath: '/market-requests', path: '/market-requests', params: null },
          { text: null, navigateToPath: '/viewmarketrequest', path: '/viewmarketrequest', params: { id: null, mrid: null }, title: true, },
          { text: 'Responses', navigateToPath: '/viewResponses', path: '/viewResponses', params: { id: null, mrid: null } },
          { text: 'Supplier Response', navigateToPath: '/response', path: '/response', params: { id: null, mrid: null, resid: null } },
        ],
        on_project_change: 'MarketRequests',
        nav_item: `${Helpers.projectsLabel}`,
        child_nav_item: 'Market Requests',
        header: 'loggedin'
      },
    },
    {
      path: '/evaluations/:id/:mrid',
      name: 'Evaluations',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/MarketRequestEvaluation.vue'),
      meta: {
        user_type: 'user',
        module: 'shortlisting',
        breadcrumbs: [
          { text: `${Helpers.projectsLabel}`, navigateToPath: null, path: null, params: null },
          { text: 'Market Requests', navigateToPath: '/market-requests', path: '/market-requests', params: null },
          { text: null, navigateToPath: '/viewmarketrequest', path: '/viewmarketrequest', params: { id: null, mrid: null }, title: true, },
          { text: 'Evaluations', navigateToPath: null, path: null, params: { id: null, mrid: null } },
        ],
        on_project_change: 'MarketRequests',
        nav_item: `${Helpers.projectsLabel}`,
        child_nav_item: 'Market Requests',
        header: 'loggedin'
      },
    },
    {
      path: '/mrfeedbackreview/:id/:mrid',
      name: 'MRFeedbackReview',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/MRFeedbackReview.vue'),
      meta: {
        user_type: 'user',
        module: 'supplier_feedback',
        breadcrumbs: [
          { text: `${Helpers.projectsLabel}`, navigateToPath: null, path: null, params: null },
          { text: 'Market Requests', navigateToPath: '/market-requests', path: '/market-requests', params: null },
          { text: null, navigateToPath: '/viewmarketrequest', path: '/viewmarketrequest', params: { id: null, mrid: null }, title: true, },
          { text: 'Feedback', navigateToPath: null, path: null, params: { id: null, mrid: null } },
        ],
        on_project_change: 'MarketRequests',
        nav_item: `${Helpers.projectsLabel}`,
        child_nav_item: 'Market Requests',
        header: 'loggedin'
      },
    },
    {
      path: '/search',
      name: 'Search',
      component: () => import(/* webpackChunkName: "about" */ './views/Search.vue'),
      meta: {
        public: true,
        header: 'public'
      },
    },
    {
      path: '/business/:publicpath',
      name: 'Profile',
      component: () => import(/* webpackChunkName: "about" */ './views/SupplierProfile.vue'),
      meta: {
        supplier: true,
        public: true,
        header: 'public'
      },
    },
    {
      path: '/plans',
      name: 'Plans',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/Plans.vue'),
      meta: {
        nav_item: 'Account',
        child_nav_item: 'Billing',
        breadcrumbs: [
          { text: 'Account', navigateToPath: null, path: null, params: null },
          { text: 'Billing', navigateToPath: '/billingdetails', path: '/billingdetails', params: null },
          { text: 'Plans', navigateToPath: null, path: null, params: null },
        ],
        header: 'loggedin'
      },
    },
    {
      path: '/billingdetails',
      name: 'Billing',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/BillingDetails.vue'),
      meta: {
        user_type: 'user',
        breadcrumbs: [
          { text: 'Account', navigateToPath: null, path: null, params: null },
          { text: 'Billing', navigateToPath: null, path: null, params: null },
        ],
        nav_item: 'Account',
        child_nav_item: 'Billing',
        header: 'loggedin'
      },
    },
    {
      path: '/preferences',
      name: 'Preferences',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/Preferences.vue'),
      meta: {
        breadcrumbs: [
          { text: 'Account', navigateToPath: null, path: null, params: null },
          { text: 'Preferences', navigateToPath: null, path: null, params: null },
        ],
        nav_item: 'Account',
        child_nav_item: 'Preferences',
        header: 'loggedin'
      },
    },
    {
      path: '/surveys',
      name: 'Surveys',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/Surveys.vue'),
      meta: {
        user_type: 'user',
        module: 'survey_responses',
        // breadcrumbs: [
        //   { text: 'Survey', navigateToPath: null, path: null, params: null },
        //   { text: 'Preferences', navigateToPath: null, path: null, params: null },
        // ],
        nav_item: 'Surveys',
        child_nav_item: 'Surveys',
        header: 'loggedin'
      },
    },
    {
      path: '/createsurvey',
      name: 'CreateSurvey',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/Survey.vue'),
      meta: {
        user_type: 'user',
        module: 'survey_responses',
        breadcrumbs: [
          { text: 'Surveys', navigateToPath: '/surveys', path: '/surveys', params: null },
          { text: 'Create New', navigateToPath: null, path: null, params: null },
        ],
        nav_item: 'Surveys',
        child_nav_item: 'Surveys',
        header: 'loggedin'
      },
    },
    {
      path: '/editsurvey/:id',
      name: 'EditSurvey',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/Survey.vue'),
      meta: {
        user_type: 'user',
        module: 'survey_responses',
        breadcrumbs: [
          { text: 'Surveys', navigateToPath: '/surveys', path: '/surveys', params: null },
          { text: null, navigateToPath: '/editsurvey', path: '/editsurvey', params: { id: null }, title: true, },
        ],
        nav_item: 'Surveys',
        child_nav_item: 'Surveys',
        header: 'loggedin'
      },
    },
    {
      path: '/viewsurvey/:id',
      name: 'ViewSurvey',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/ViewSurvey.vue'),
      meta: {
        user_type: 'user',
        module: 'survey_responses',
        breadcrumbs: [
          { text: 'Surveys', navigateToPath: '/surveys', path: '/surveys', params: null },
          { text: null, navigateToPath: '/viewsurvey', path: '/viewsurvey', params: { id: null }, title: true, },
        ],
        nav_item: 'Surveys',
        child_nav_item: 'Surveys',
        header: 'loggedin'
      },
    },
    {
      path: '/business/:publicpath/:surveypath',
      name: 'SubmitSurvey',
      component: () => import(/* webpackChunkName: "about" */ './views/SubmitSurvey.vue'),
      meta: {
        public: true,
        footer: true,
        header: 'none'
      },
    },
    {
      path: '/surveyresponse/:id/:resid',
      name: 'SurveyResponse',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/SubmitSurvey.vue'),
      meta: {
        user_type: 'user',
        module: 'survey_responses',
        breadcrumbs: [
          { text: 'Surveys', navigateToPath: '/surveys', path: '/surveys', params: null },
          { text: null, navigateToPath: '/viewsurvey', path: '/viewsurvey', params: null, title: true, },
          { text: 'Survey Responses', navigateToPath: '/surveyresponses', path: '/surveyresponses', params: { id: null }},
          { text: 'View Response', navigateToPath: '/surveyresponse', path: '/surveyresponse', params: { id: null }},
        ],
        header: 'loggedin'        
      },
    },
    {
      path: '/surveyresponses/:id',
      name: 'SurveyResponses',
      beforeEnter: guard,
      component: () => import(/* webpackChunkName: "about" */ './views/SurveyResponses.vue'),
      meta: {
        module: 'survey_responses',
        breadcrumbs: [
          { text: 'Surveys', navigateToPath: '/surveys', path: '/surveys', params: null },
          { text: null, navigateToPath: '/viewsurvey', path: '/viewsurvey', params: { id: null }, title: true, },
          { text: 'Survey Responses', navigateToPath: '/surveyresponses', path: '/surveyresponses', params: { id: null }},
        ],
        nav_item: 'Surveys',
        child_nav_item: 'Surveys',
        header: 'loggedin'
      },

    },
    // {
    //   path: '/people/:path',
    //   name: 'PeopleProfile',
    //   component: () => import(/* webpackChunkName: "about" */ './views/PeopleProfile.vue'),
    //   meta: {
    //     general: true,
    //     header: 'by_auth_status'
    //   },
    // },
    // {
    //   path: '/search-results',
    //   name: 'SearchResults',
    //   component: () => import(/* webpackChunkName: "about" */ './views/SearchResult.vue'),
    //   meta: {
    //     header: 'loggedin'
    //   },
    // },
  ],
});

router.afterEach((to, from) => {
  if (store.getters.userLoggedIn) {
    inlineManualPlayer().then((res: any) => {
      if ((window as any).inline_manual_player !== undefined) {
        (window as any).inline_manual_player.update();
      }
    });
  }
});

const inlineManualPlayer = async () => {
  let retries = 0;
  const timer = setInterval(function () {
    if (typeof (window as any).createInlineManualPlayer !== 'undefined') {
      (window as any).createInlineManualPlayer((window as any).inlineManualPlayerData);
      clearInterval(timer);
    } else if (retries > 100) {
      clearInterval(timer);
    }
    retries++;
  }, 50);
  return timer;
};

export default router;
